import { hotVideos } from "@/mocks/homeData";

export default function HotVideos() {
  return (
    <section id="videos" className="px-4 md:px-8 py-10 border-t border-background-200/60">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] text-primary-600 font-label mb-2">RECOMMENDED</p>
          <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">热门视频推荐</h2>
        </div>
        <a
          href="#ranking"
          className="hidden md:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 cursor-pointer"
        >
          更多推荐 <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {hotVideos.map((video) => (
          <a href="#ranking" key={video.title} className="group block cursor-pointer">
            <div className="relative w-full h-[230px] md:h-[280px] rounded-lg overflow-hidden bg-background-100">
              <img
                src={video.image}
                alt={video.title}
                title={`${video.title} 91网热门视频`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent" />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-black/45 text-white text-[11px]">
                {video.tag}
              </span>
              <span className="absolute top-3 right-3 px-2 py-0.5 rounded bg-black/55 text-white text-[11px]">
                {video.duration}
              </span>
              <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-white text-[11px]">
                <i className="ri-play-circle-line" /> {video.plays}
              </span>
              <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="w-12 h-12 rounded-full bg-background-50/95 flex items-center justify-center text-primary-600">
                  <i className="ri-play-fill text-xl" />
                </span>
              </span>
            </div>
            <h3 className="mt-3 font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600">
              {video.title}
            </h3>
            <div className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-user-3-line" /> {video.author}
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}